export function filterBySearch<T>(items: T[], searchTerm: string, getSearchableFields: (item: T) => string[]): T[] {
    const normalizedSearch = searchTerm.trim().toLowerCase()
    if (!normalizedSearch) return items

    return items.filter((item) => getSearchableFields(item).join(' ').toLowerCase().includes(normalizedSearch))
}
